export default __webpack_public_path__ + "static/media/logo-support.7b252302.svg";